(function () {
  function destroySwiper(sectionId) {
    var key = 'beNavSwiper_' + sectionId;
    var inst = window[key];
    if (inst && typeof inst.destroy === 'function') inst.destroy(true, true);
    window[key] = null;
  }

  function initSwiper(sectionId) {
    var key = 'beNavSwiper_' + sectionId;
    if (window[key]) return;
    var el = document.getElementById('be-nav-swiper-' + sectionId);
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
      setTimeout(function () { initSwiper(sectionId); }, 50);
      return;
    }

    window[key] = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      speed: 400,
      navigation: {
        nextEl: document.getElementById('be-nav-next-' + sectionId),
        prevEl: document.getElementById('be-nav-prev-' + sectionId)
      },
      breakpoints: {
        750: {
          allowTouchMove: false
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-be-nav-section]').forEach(function (root) {
      initSwiper(root.dataset.beNavSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail) destroySwiper(e.detail.sectionId);
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail) return;
    destroySwiper(e.detail.sectionId);
    initSwiper(e.detail.sectionId);
  });
})();
